import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c5530bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "addr" }
const _hoisted_2 = { class: "action" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "abs"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex-end" }

import { ref, watch, nextTick, toRaw } from 'vue'
import {
  taxAccountList,
  taxAccountRemove,
  taxAccountDefault
} from '@/apis/user'
import { t } from '@/plugins/i18n'
import { ElMessage } from 'element-plus'
import setName from '@/util/useArea'
import EditTaxAccount from '@/components/tax/EditTaxAccount.vue'
import { confirmDelTaxAccount } from '@/util/useConfirm'
import { useRequest } from '@/util/useLoading'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: ['source', 'defaultSelection'],
  emits: ['updateSel'],
  setup(__props, { expose, emit }) {

const props = __props
const store = useStore()


const columns = [
  '金融机构代码',
  '分行代码',
  '账号_关税',
  '进口商标准代码',
  '操作'
]

const taxTable = ref()

const selected: any = ref([])
const defaultSelection = ref(props.defaultSelection)
const data = ref([])
const item: any = ref(null)

const [loading, getData] = useRequest(() => {
  data.value = []
  return taxAccountList({ pageNum: 1, pageSize: 50, customerShopId: store.getters.curShop }).then((res) => {
    if (res.success) {
      data.value = res.data.records

      // 初始化默认选中
      if (defaultSelection.value) {
        nextTick(() => {
          const tableData = taxTable.value.store.states.data.value
          const row = tableData.filter((v) => v.id === defaultSelection.value.id)[0]
          row && handleSelect([row])
          defaultSelection.value = null
        })
      }
    }
  })
})
const _getData = () => {
  getData()
}

const refresh = () => {
  getData()
}

const visible = ref(false)
const editType = ref('add')
const editData = ref({})
const edit = (data: any) => {
  editType.value = 'edit'
  editData.value = { ...data }
  visible.value = true
  item.value = data
}
const addAccount = () => {
  editType.value = 'add'
  editData.value = {}
  visible.value = true
}
const del = (item: any) => {
  confirmDelTaxAccount(
    () => taxAccountRemove(item).then(_getData),
    () => {}
  )
}

const handleSelect = (val: any) => {
  console.log('handleSelect')
  console.log(val)
  console.log(val[val.length - 1])
  const test = toRaw(data.value)
  taxTable.value.clearSelection()
  val.length && taxTable.value.toggleRowSelection(val[val.length - 1])
  selected.value = val.length ? val[val.length - 1] : null
  emit('updateSel', selected.value)
}
const selectionClass = (row) => {
  if (row.columnIndex === 0) {
    return 'disableSelect'
  }
}
// const delLot = () => {
//   confirmDelAddr(
//     () => Promise.all(selected.value.map((v: any) => delApi(v))).then(_getData),
//     () => {}
//   )
// }

const setDefault = (item: any) => {
  taxAccountDefault({ id: item.id }).then(_getData)
}

getData()
watch(() => props.name, _getData)

expose({
  refresh
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createVNode(_component_el_table, {
        class: "mb_20",
        data: data.value,
        border: "",
        onSelect: handleSelect,
        "table-layout": "auto",
        ref: (_value, _refs) => {
          _refs['taxTable'] = _value
          taxTable.value = _value
        },
        "header-cell-class-name": selectionClass,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          (__props.source !== 'setupTax')
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                type: "selection",
                width: "55",
                align: "center"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            prop: "financialInstitutionCode",
            label: _unref(t)(columns[0]),
            align: "center"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "branchCode",
            label: _unref(t)(columns[1]),
            "min-width": "200",
            align: "center"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "taxDeductionAccount",
            label: _unref(t)(columns[2]),
            align: "center"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "importerCode",
            label: _unref(t)(columns[3]),
            align: "center"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            prop: "action",
            label: _unref(t)(columns[4]),
            width: "160",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("label", {
                  class: "btn",
                  onClick: ($event: any) => (edit(row))
                }, _toDisplayString(_unref(t)('编辑')), 9, _hoisted_3),
                (__props.source === 'setupTax')
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 0,
                      class: "btn",
                      onClick: ($event: any) => (del(row))
                    }, _toDisplayString(_unref(t)('删除')), 9, _hoisted_4))
                  : _createCommentVNode("", true),
                (row.isDefault)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(t)('默认')), 1))
                  : _createCommentVNode("", true),
                _hoisted_6,
                (!row.isDefault && __props.source === 'setupTax')
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 2,
                      class: "btn",
                      onClick: ($event: any) => (setDefault(row))
                    }, _toDisplayString(_unref(t)('设为默认扣税账号')), 9, _hoisted_7))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"]), [
        [_directive_loading, _unref(loading)]
      ]),
      _createElementVNode("div", _hoisted_8, [
        (__props.source !== 'setupTax')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: addAccount,
              type: "text"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('添加新账号')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(EditTaxAccount, {
      ref: (_value, _refs) => {
        _refs['editTaxAccount'] = _value
      },
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      type: editType.value,
      data: editData.value,
      onRefresh: refresh
    }, null, 8, ["visible", "type", "data"])
  ], 64))
}
}

})